import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home.vue"

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        page: 1
      }
    },
    {
      path: "/contest-finished",
      name: "contest-closed",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/ContestClosed.vue"),
      meta: {
        page: 7
      }
    },
    {
      path: "/contest-rules",
      name: "rules",
      component: () =>
        import(/* webpackChunkName: "rules" */ "./views/Rules.vue"),
      meta: {
        page: 8
      }
    },
    {
      path: "/registration",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "destination" */ "./views/Destination.vue"),
      meta: {
        page: 2
      }
    },
    {
      path: "/status",
      name: "status",
      component: () =>
        import(/* webpackChunkName: "status" */ "./views/Status.vue"),
      meta: {
        page: 3
      }
    },
    {
      path: "/accept",
      name: "accept",
      component: () =>
        import(/* webpackChunkName: "accept" */ "./views/Accept.vue"),
      meta: {
        page: 0
      }
    },
    {
      path: "/share",
      name: "share",
      component: () =>
        import(/* webpackChunkName: "share" */ "./views/Share.vue"),
      props: true,
      meta: {
        page: 6
      }
    },
    {
      path: "/unsubscribe",
      name: "unsubscribe",
      component: () =>
        import(/* webpackChunkName: "unsubscribe" */ "./views/Unsubscribe.vue"),
      meta: {
        page: 6
      }
    },
    {
      path: "*",
      name: "error",
      component: () =>
        import(/* webpackChunkName: "error" */ "./views/Error.vue"),
      meta: {
        page: 10
      }
    }
  ]
})
